import(/* webpackMode: "eager" */ "/Users/panxo/Development/LigasDeportivas/web/src/app/global-error.tsx");
